$(document).ready(function () {
  $(".slider-gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: true,
    asNavFor: "",
    infinite: true,
    cssEase: "linear",
    autoplay: true,
    speed: 500,
    pauseOnHover: false,
    pauseOnFocus: true,
    pauseOnDotsHover: true,
    pauseOnScroll: true,
  });
});
